<template>
  <div>
    <!-- <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading> -->
    <div
      id="cancelSubLicence"
      class="modal fade"
      :class="{ show: show }"
      style="background: rgba(0,0,0,0.5)"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div :class="modalStyle || ' modal-dialog'" class="modal-dialog-centered">
        <div class="modal-content" id="modal">
          <div class="card-body">
            <div
              v-if="header"
              class="d-flex justify-content-between mx-0 mb-4"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1);margin-bottom: 15px;"
            >
              <h5 class="mx-0 px-2" v-if="header">
                {{ header }}
              </h5>

              <p
                class="cursor-pointer"
                @click="$emit(doCancel)"
                v-if="showClose"
              >
                <img src="../../assets/images/Vector (1).png" alt="" />
              </p>
            </div>

            <div
              v-if="mssg"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>

            <form class="p-2" @submit.prevent="$emit(doSubmit)" v-if="showBtn">
              <slot />
              <div
                class="form-group mt-5"
                style="display:flex; justify-content: space-between"
              >
                <button
                  @click="$emit(doCancel)"
                  type="button"
                  class="btn btn-secondary"
                >
                  {{ cancelText }}
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :class="btnClass"
                  :disabled="disabled"
                >
                  <!-- {{ $t("Yes, Turn Off this Licence") }} -->
                  {{ submitText }}
                </button>
              </div>
            </form>
            <slot v-else />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";

export default {
  name: "ModalWrapper",
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    modalStyle: {
      type: String,
      default: "",
    },
    showBtn: {
      type: Boolean,
      default: true,
    },
    btnClass: String,
    header: String,
    mssg: String,
    Errormssg: String,
    submitText: {
      type: String,
      default: "Submit",
    },
    doSubmit: String,
    doCancel: String,
    cancelText: {
      type: String,
      default: "Cancel",
    },
    showClose: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  components: {
    // Loading,
  },
  mounted() {},
  directives: {
    clickOutside: vClickOutside.directive,
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 500px !important;
}
button:focus {
  outline: none;
  border: none;
}
</style>
<i18n>
{
	"en": {
		"add_user": "Add a User",
		"all_users": "All Users",
		"edit_user": "Edit User",
		"email": "Email",
		"full_name": "Full Name",
		"man_user_right": "Manage user rights for members of your business",
		"manage": "Manager",
		"must_contain": "Must conain only Letters",
		"name": "Name",
		"phone": "Phone Number",
		"staff": "Staff",
		"user_rights": "User Rights",
		"valid_phone": "This phone number is not valid"
	},
	"fr": {
		"add_user": "Ajouter un utilisateur",
		"all_users": "Tous les utilisateurs",
		"edit_user": "Modifier l'utilisateur",
		"email": "E-mail",
		"full_name": "Nom et prénom",
		"man_user_right": "Gérez les droits d'utilisation des membres de votre entreprise",
		"manage": "Directeur",
		"must_contain": "Ne doit contenir que des lettres",
		"name": "Nom",
		"phone": "Numéro de téléphone",
		"staff": "Personnel",
		"user_rights": "Droits de l'utilisateur",
		"valid_phone": "Ce numéro de téléphone n'est pas valide"
	},
	"sw": {
		"add_user": "ONGEZA MTUMIAJI",
		"all_users": "Watumiaji Wote",
		"edit_user": "Badilisha mtumiaji",
		"email": "Barua pepe",
		"full_name": "Jina kamili",
		"man_user_right": "Dhibiti haki za mtumiaji za wanachama wa biashara yako",
		"manage": "Meneja",
		"must_contain": "Lazima iwe na Barua tu",
		"name": "Jina",
		"phone": "Nambari ya simu",
		"staff": "STAFF",
		"user_rights": "Haki za Mtumiaji",
		"valid_phone": "Nambari hii ya simu si sahihi"
	}
}
</i18n>
